<template>
  <div>
    <nav>
      <div id="toggle-btn" @click="toggleHamburgerMenu()">
        <div class="btn-burger"></div>
      </div>
      <div class="burgerMenu__menu" id="burgerMenu__menu">
        <ul class="menu__link-wrapper">
          <li
            v-for="route in routes"
            :key="route.id"
            @click="scrollToAnchor(route.id)"
            class="text--grey menu__link flex flex-justify-center flex-align-center"
          >
            {{ route.title }}
          </li>
        </ul>
      </div>
    </nav>
    <contactMe v-if="isContactMe" @close="isContactMe = false" />
  </div>
</template>
<script>
import contactMe from "../home/contactMe.vue";
export default {
  components: { contactMe },
  data() {
    return {
      isHamburgerMenuActive: false,
      isContactMe: false,
      routes: [
        { id: "home-hero-section", title: "Home" },
        { id: "about-me-section", title: "About" },
        { id: "my-skills-section", title: "Skills" },
        { id: "my-projects-section", title: "Projects" },
        { id: "contact-me-section", title: "Contact" },
      ],
    };
  },
  computed: {
    isWebView() {
      return this.$store.getters.getIsWebView;
    },
  },
  methods: {
    toggleHamburgerMenu() {
      document.body.classList.toggle("stop-scrolling");
      document.getElementById("toggle-btn").classList.toggle("active");
      document.getElementById("burgerMenu__menu").classList.toggle("active");
      this.isHamburgerMenuActive = !this.isHamburgerMenuActive;
    },
    scrollToAnchor(id) {
      if (id == "contact-me-section") {
        this.isContactMe = true;
      } else {
        const top = document.getElementById(id).offsetTop;
        window.scrollTo(0, top);
      }
      this.toggleHamburgerMenu();
    },
  },
};
</script>
<style lang="scss" scoped>
#toggle-btn {
  height: 25px;
  width: 30px;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10;
  &.active {
    .btn-burger {
      transform: rotate(135deg);
    }
    .btn-burger::before,
    .btn-burger::after {
      top: 0;
      transform: rotate(90deg);
    }
  }
}

.btn-burger {
  position: relative;
  max-width: 30px;
  max-height: 5px;
  min-width: 25px;
  min-height: 3px;
  width: 7vh;
  height: 2vh;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  transition: all 0.7s ease;

  &::before,
  &::after {
    content: "";
    position: absolute;
    z-index: 1;
    top: -10px;
    max-width: inherit;
    max-height: inherit;
    min-width: inherit;
    min-height: inherit;
    width: inherit;
    height: inherit;
    border-radius: inherit;
    background: inherit;
  }
  &::after {
    top: 10px;
  }
}
.burgerMenu__menu {
  right: -1190px;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 2;
  cursor: pointer;
  transition: all 300ms linear;
  padding-top: 10vh;

  &.active {
    right: 0px;
  }
  ul {
    list-style: none;
    padding: 0;
    li {
      padding: 15px 10px;
      width: 50%;
      margin: auto;
      color: white;
      text-decoration: none;
      &.router-link-exact-active {
        color: #ffffff !important;
        border-bottom: 1px solid white;
        padding-bottom: 0.5rem;
      }
    }
  }
}
.menu__link-wrapper {
  margin-top: 150px;
}
.menu__link {
  padding-top: 100px;
}
</style>
